import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

// Area - Get All (Read)
export const GetAllArea = createAsyncThunk(
  "masters/area/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Masters.Area}?name=${filter?.name || ""}&city_id=${filter?.city_id || ""
        }&state_id=${filter?.state_id || ""}&country_id=${filter?.country_id || ""
        }&pincode_id=${filter?.pincode_id || ""}&page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page || IDS.PERPAGE
        }`
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Area - Get (Read)
export const GetArea = createAsyncThunk(
  "masters/area/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Masters.Area}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Area - Create (Add)
export const AddArea = createAsyncThunk(
  "masters/area/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Masters.Area, data);
      return res;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Area - Update
export const UpdateArea = createAsyncThunk(
  "masters/area/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(`${APIS.Masters.Area}/${id}`, {
        name: data.name,
        country_id: data.country_id,
        state_id: data.state_id,
        city_id: data.city_id,
        pincode_id: data.pincode_id,
      });
      return res;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Area - Delete
export const DeleteArea = createAsyncThunk(
  "masters/area/delete",
  async (id, { rejectWithValue }) => {
    try {
      await DELETE(`${APIS.Masters.Area}/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Area - Status
export const StatusArea = createAsyncThunk(
  "masters/area/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Masters.Area}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "area",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllArea.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllArea.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllArea.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetArea.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetArea.fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetArea.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AddArea.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AddArea.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data.unshift(action.payload.data);
      })
      .addCase(AddArea.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(UpdateArea.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(UpdateArea.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        const index = state.data.findIndex(
          (area) => area.id === action.payload?.data?.id
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(UpdateArea.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(DeleteArea.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(DeleteArea.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = state.data.filter((city) => city.id !== action.payload);
      })
      .addCase(DeleteArea.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(StatusArea.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusArea.fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(StatusArea.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export default Slice.reducer;
